import React, { useEffect, useState } from 'react';

import Tracking from '@vromo/analytics';
import styled from '@emotion/styled';
import Color from 'color';
import { observer } from 'mobx-react-lite';
import { when } from 'mobx';

import { racJob, racAaacJob } from './helpers';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useStore } from '@vromo/mobx-react/mobx-react';

const Caret = styled.span`
    color: ${({ theme }) => (Color(theme.background).isLight() ? 'black' : '#EFEFEF')};
`;

export default observer(function ExpandableView({
    container: Container,
    expandedContent,
    collapsedContent
}) {
    const [expanded, setExpanded] = useState(false);
    const rootStore = useStore('rootStore');

    useEffect(() => {
        when(
            () => !!rootStore.jobs.length,
            () => {
                if (racJob(rootStore.jobs.first()) || racAaacJob(rootStore.jobs.first())) {
                    setExpanded(true);
                }
            }
        );
    }, []);

    function toggleExpansionState() {
        setExpanded(!expanded);

        if (!expanded) {
            Tracking.track('Tracking Link Details Expanded');
        }
    }

    return (
        <Container expanded={expanded}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    cursor: 'pointer'
                }}>
                <div onClick={toggleExpansionState}>{collapsedContent}</div>
                <div onClick={toggleExpansionState}>
                    <Caret>
                        <FontAwesome icon={expanded ? 'angle-down' : 'angle-up'} x2 />
                    </Caret>
                </div>
            </div>
            {expanded ? expandedContent : null}
        </Container>
    );
});
